<script setup lang="ts">
import type { NovaSearchResultItemPostProps } from './NovaSearchResultItemPost.types'

defineProps<NovaSearchResultItemPostProps>()

const { humanize } = useDateFormat()
</script>

<template>
  <button type="button" class="search-result-item-post">
    <span class="title">
      {{ source.nttSj }}
    </span>

    <span class="metas">
      <span class="meta user-name">
        {{ source.userNcnm }}
      </span>
      <span class="meta create-at">
        {{ humanize(source.nttRegistDt) }}
      </span>
    </span>
  </button>
</template>

<style lang="scss" scoped>
.search-result-item-post {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 20px;
  background-color: $color-bg-3;
  border-radius: $radius-10;
  > .title {
    @include text-style($text-body-14-regular);
    @include ellipsis(2);
    color: $color-text-2;
  }

  .metas {
    display: flex;
    flex-direction: row;
    gap: 10px;

    > .meta {
      @include text-style($text-body-12-regular);
      color: $color-text-3;
    }
  }

  @include mobile {
    gap: 10px;
    padding: 15px;
  }
}
</style>
